import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=2cd653cd&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=2cd653cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd653cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cd653cd')) {
      api.createRecord('2cd653cd', component.options)
    } else {
      api.reload('2cd653cd', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=2cd653cd&scoped=true&", function () {
      api.rerender('2cd653cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22omdsZ9bvfzf/JS/comp/SearchFilterTokens.vue"
export default component.exports